import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Products
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getCategories = () => api.get('/products/categories/list');

// Orders
export const createOrder = (data) => api.post('/orders', data);
export const getOrder = (orderId) => api.get(`/orders/${orderId}`);
export const getOrderHistory = (phone) => api.get(`/orders/history/${phone}`);
export const simulatePayment = (orderId) => api.post(`/orders/${orderId}/simulate`);
export const cancelOrder = (orderId) => api.post(`/orders/${orderId}/cancel`);
